import { render, staticRenderFns } from "./myinfo-nationality.vue?vue&type=template&id=2bd2e628&"
import script from "./myinfo-nationality.vue?vue&type=script&lang=js&"
export * from "./myinfo-nationality.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports